import { render, staticRenderFns } from "./HeroCategoryFlower.vue?vue&type=template&id=2ec1a2bc&"
import script from "./HeroCategoryFlower.vue?vue&type=script&lang=js&"
export * from "./HeroCategoryFlower.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports